import { useContext } from 'react';
import { FaPen, FaTrash } from 'react-icons/fa';
import { Box, Card, Checkbox, Text, Title } from 'uisos';
import { CustomerModel } from '../../@types/api';
import { ModalContext } from '../../context/ModalContext';
import { ProfileContext } from '../../context/ProfileContext';
import useMediaQuery from '../../hooks/useMediaQuery';
import { AllergyIcon } from '../AllergyIcon';

interface AllergyCardProps {
  data: {};
}

export function AllergyCard({ data }: AllergyCardProps) {
  const { openModal } = useContext(ModalContext);
  const { setId, remove, setCardVisibility } = useContext(ProfileContext);
  const { symptons, name, card_visibility, type, id } =
    data as unknown as CustomerModel['allergies'][0];
  const isMobile = useMediaQuery(768);

  return (
    <Card variant="middle" style={{ width: '100%' }}>
      <Card.Main separator padding={15}>
        <Box align="center" height={57} justify="center" margin={[0, 16, 0, 0]} width="15%">
          <AllergyIcon type={type} size={isMobile ? 32 : 52} />
        </Box>
        <Box align="flex-start" direction="column" height={64} justify="space-evenly" width="60%">
          <Title level={6} weight="regular">
            {name}
          </Title>
          <Text size="xs">{symptons}</Text>
        </Box>
        <Box align="center" justify="space-around" height={57} width="25%">
          <FaPen
            size={isMobile ? 18 : 24}
            aria-hidden="true"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              openModal('update'), setId(id);
            }}
          />
          <FaTrash
            aria-hidden="true"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              openModal('remove'), setId(id);
            }}
            size={isMobile ? 18 : 24}
          />
        </Box>
      </Card.Main>
      <Card.Footer padding={[8, 18]}>
        <Checkbox checked={card_visibility} name="visibility" onClick={() => setCardVisibility(id)}>
          Visibilidade no cartão IASOS
        </Checkbox>
      </Card.Footer>
    </Card>
  );
}
